import React, { Component } from "react";

import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";

import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';



import LoadingOverlay from "./LoadingOverlay";
export default class Motoraddonstable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.motoraddonstable_Id,
          sortable: true,
          cell: (row) => <span>{row.motoraddonstable_Id}</span>,
        },
        { name: "Base Product Id", selector: (row, i) => row.baseProductId, sortable: true, cell: (row) => <span>{row.baseProductId}</span>, }, { name: "Product Name", selector: (row, i) => row.productName, sortable: true, cell: (row) => <span>{row.productName}</span>, }, { name: "Addons", selector: (row, i) => row.addons, sortable: true, cell: (row) => <span>{row.addons}</span>, }, { name: "Default Value", selector: (row, i) => row.defaultValue, sortable: true, cell: (row) => <span>{row.defaultValue}</span>, }, { name: "Addon Type", selector: (row, i) => row.addons_type, sortable: true, cell: (row) => <span>{row.addons_type}</span>, },
        { name: "Max Age", selector: (row, i) => row.maxAge, sortable: true, cell: (row) => <span>{row.maxAge}</span>, },//***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.MotoraddonstableeditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      motoraddonstable_Id: "",
      baseProductId: '', productName: '', addons: '', defaultValue: '', addons_type: '',
      maxAge: '',//***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic

  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;
    let validationResult = { isValid: true, message: "" };
    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {

          validationResult = ValidationUtils.validateAddress(value);

        } else if (validationOptions?.maxLength) {

          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);

        } else {

          validationResult = { isValid: true, message: "" };

        }

        break;



      case 'mail':

      case 'email':

        validationResult = ValidationUtils.validateEmail(value);

        break;



      case 'telephone':

      case 'phone':

        validationResult = ValidationUtils.validatePhone(value);

        break;



      case 'number':

        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);

        break;



      case 'dob_child':

        validationResult = ValidationUtils.validateDOBMinAge(value);

        break;



      case 'dob_adult':

        validationResult = ValidationUtils.validateDOBAdult(value);

        break;



      case 'pan':

        validationResult = ValidationUtils.validatePAN(value);

        break;



      case 'aadhaar':

        validationResult = ValidationUtils.validateAadhaar(value);

        break;



      case 'password':

        if (value.length < 6) {

          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };

        }

        break;



      default:

        validationResult = { isValid: true, message: "" };

    }



    // Check required field validation

    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {

      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);

    }



    const errors = { ...this.state.errors };

    if (!validationResult.isValid) {

      errors[fieldName] = validationResult.message;

    } else {

      delete errors[fieldName];

    }



    this.setState({ errors });

    return validationResult.isValid;

  };



  // Enhanced field change handler with auto-validation

  handleFieldChange = (fieldName, value, fieldConfig) => {

    this.setState({

      [fieldName]: value,

      touched: { ...this.state.touched, [fieldName]: true }

    });



    // Only validate if field has been touched

    if (this.state.touched[fieldName] || value !== "") {

      this.validateField(fieldName, value, fieldConfig);

    }

  };



  // Enhanced field blur handler for validation

  handleFieldBlur = (fieldName, value, fieldConfig) => {

    this.setState({

      touched: { ...this.state.touched, [fieldName]: true }

    });

    this.validateField(fieldName, value, fieldConfig);

  };



  // Check if form is valid - auto-generated based on required fields

  isFormValid = () => {

    const { errors } = this.state;



    // Auto-generated required field validation

    // No required fields defined





    return Object.keys(errors).length === 0;

  };



  // Auto-generated validation for all fields before submission

  validateAllFields = () => {

    const fieldConfigs = [

      { fieldName: 'baseProductId', inputType: 'Text', displayName: 'Base Product Id', validationOptions: { isRequired: false } },

      { fieldName: 'productName', inputType: 'Text', displayName: 'Product Name', validationOptions: { isRequired: false } },

      { fieldName: 'addons', inputType: 'Text', displayName: 'Addons', validationOptions: { isRequired: false } },

      { fieldName: 'defaultValue', inputType: 'Text', displayName: 'Default Value', validationOptions: { isRequired: false } },

      { fieldName: 'addons_type', inputType: 'Text', displayName: 'Addon Type', validationOptions: { isRequired: false } }

    ];



    fieldConfigs.forEach(config => {

      const value = this.state[config.fieldName];

      this.validateField(config.fieldName, value, config);

    });



    const touched = {};

    fieldConfigs.forEach(config => {

      touched[config.fieldName] = true;

    });

    this.setState({ touched });



  };



  // offcanvas Open

  handleOffcanvasShow = () => {

    this.setState({

      show: true,

      errors: {},

      touched: {},

      baseProductId: '', productName: '', addons: '', defaultValue: '', addons_type: '',

    });

  };



  // Offcanvas close button

  handleOffcanvasClose = () => {

    this.setState({

      show: false,

      isEditing: false,

      errors: {},

      touched: {},

      baseProductId: '', productName: '', addons: '', defaultValue: '', addons_type: '',

    });

  };



  // Enhanced toast notifications

  showToast = (msg, type) => {

    switch (type) {

      case "success":

        toast.success(msg);

        break;

      case "error":

        toast.error(msg);

        break;

      case "warning":

        toast.warn(msg);

        break;

      default:

        toast.info(msg);

    }

  };



  MotoraddonstableeditHandler = (row) => {

    this.setState({

      isEditing: true,

      show: true,

      motoraddonstable_Id: row.motoraddonstable_Id,

      baseProductId: row.baseProductId, productName: row.productName, addons: row.addons, defaultValue: row.defaultValue, addons_type: row.addons_type,

      maxAge: row.maxAge,//***editstate

      errors: {},

      touched: {}

    });

  }



  MotoraddonstablefetchHandler = () => {

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);



    fetch(configData.api_url + 'C_Motoraddonstable/list', {

      method: 'POST',

      mode: 'cors',

      body: formData

    })

      .then(response => response.json())

      .then((data) => {

        if (data.status === "success") {

          this.setState({ data: data.list });

        }

      })

      .catch((error) => {

        console.error("Fetch error:", error);

        this.showToast("Failed to load data", "error");

      });

  }



  MotoraddonstablesubmitHandler = (e) => {

    e.preventDefault();



    // Validate all fields before submission

    this.validateAllFields();



    if (!this.isFormValid()) {

      this.showToast("Please fix all errors before submitting", "error");

      return;

    }



    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append('baseProductId', this.state.baseProductId);

    formData.append('productName', this.state.productName);

    formData.append('addons', this.state.addons);

    formData.append('defaultValue', this.state.defaultValue);

    formData.append('addons_type', this.state.addons_type);



    formData.append('maxAge', this.state.maxAge);
    //***tableData*



    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Motoraddonstable/add', {

      method: 'POST',

      mode: 'cors',

      body: formData

    })

      .then(response => response.json())

      .then((data) => {

        this.showToast(data.message, data.status);

        if (data.status === "success") {

          this.MotoraddonstablefetchHandler();

          this.handleOffcanvasClose();

          this.setState({ baseProductId: '', productName: '', addons: '', defaultValue: '', addons_type: '', });

        }

      
        this.setState({ loading: false });})

      .catch((error) => {

        console.error("Submit error:", error);

        this.showToast("Failed to save data", "error");

      
        this.setState({ loading: false });});

  }



  MotoraddonstableupdateHandler = (e) => {

    e.preventDefault();



    // Validate all fields before submission

    this.validateAllFields();



    if (!this.isFormValid()) {

      this.showToast("Please fix all errors before updating", "error");

      return;

    }



    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("motoraddonstable_Id", this.state.motoraddonstable_Id);

    formData.append('baseProductId', this.state.baseProductId);

    formData.append('productName', this.state.productName);

    formData.append('addons', this.state.addons);

    formData.append('defaultValue', this.state.defaultValue);

    formData.append('addons_type', this.state.addons_type);



    formData.append('maxAge', this.state.maxAge);
    //***tableData1



    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Motoraddonstable/update', {

      method: 'POST',

      mode: 'cors',

      body: formData

    })

      .then(response => response.json())

      .then((data) => {

        this.showToast(data.message, data.status);

        if (data.status === "success") {

          this.MotoraddonstablefetchHandler();

          this.handleOffcanvasClose();

        }

      
        this.setState({ loading: false });})

      .catch((error) => {

        console.error("Update error:", error);

        this.showToast("Failed to update data", "error");

      
        this.setState({ loading: false });});

  }



  componentDidMount() {

    this.MotoraddonstablefetchHandler();



    //***componentDidMount

  }



  handlebaseProductIdChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ baseProductId: fieldValue });

  }; handleproductNameChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ productName: fieldValue });

  }; handleaddonsChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ addons: fieldValue });

  }; handledefaultValueChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ defaultValue: fieldValue });

  }; handleaddons_typeChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ addons_type: fieldValue });

  };


  handlemaxAgeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maxAge: fieldValue });
  };//***inputFunctions



  handleRowSelect = (row) => {

    this.setState({

      selectedRow: row.index,

    });

  };



  handleRowUpdate = (newData, oldData) => {

    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });

  };



  handleEdit = (row) => {

    console.log(`Editing row with ID ${row.id}`);

  };



  handleDelete = (row, index) => {

    if (!window.confirm(`Are you sure you want to delete this motoraddonstable?`)) {

      return;

    }



    var formData = new FormData();

    formData.append('motoraddonstable_Id', row.motoraddonstable_Id);

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Motoraddonstable/delete', {

      method: 'POST',

      mode: 'cors',

      body: formData

    })

      .then(response => response.json())

      .then((data) => {

        this.showToast(data.message, data.status);

        if (data.status === "success") {

          this.MotoraddonstablefetchHandler();

        }

      
        this.setState({ loading: false });})

      .catch((error) => {

        console.error("Delete error:", error);

        this.showToast("Failed to delete data", "error");

      
        this.setState({ loading: false });});

  };



  handlePageChange = (page) => {

    this.setState({ currentPage: page });

  };



  handlePerRowsChange = (newPerPage, page) => {

    this.setState({ itemsPerPage: newPerPage, currentPage: page });

  };



  handleFilter = (e) => {

    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {

      return Object.values(row).join(" ").toLowerCase().includes(searchValue);

    });

    this.setState({ filteredData });

  };



  // Helper method to render error message

  renderFieldError = (fieldName) => {

    const { errors, touched } = this.state;

    if (errors[fieldName] && touched[fieldName]) {

      return (

        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>

          <i className="bi bi-exclamation-circle me-1"></i>

          {errors[fieldName]}

        </div>

      );

    }

    return null;

  };



  // Auto-generated form field renderer based on inputType and validation options

  renderFormField = (fieldConfig) => {

    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;

    const value = this.state[fieldName] || "";

    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];



    let inputElement;



    switch (inputType.toLowerCase()) {

      case 'dob_child':

      case 'dob_adult':

      case 'date':

        inputElement = (

          <Form.Control

            type="date"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

          />

        );

        break;



      case 'telephone':

      case 'phone':

        inputElement = (

          <Form.Control

            type="tel"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder="Enter 10-digit mobile number"

          />

        );

        break;



      case 'mail':

      case 'email':

        inputElement = (

          <Form.Control

            type="email"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder="Enter email address"

          />

        );

        break;



      case 'password':

        inputElement = (

          <Form.Control

            type="password"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder="Enter password"

          />

        );

        break;



      case 'number':

        inputElement = (

          <Form.Control

            type="number"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder={`Enter ${displayName.toLowerCase()}`}

          />

        );

        break;



      case 'pan':

        inputElement = (

          <Form.Control

            type="text"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder="ABCPA1234B"

            maxLength="10"

          />

        );

        break;



      case 'aadhaar':

        inputElement = (

          <Form.Control

            type="text"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder="123456789012"

            maxLength="12"

          />

        );

        break;



      default: // text and other types

        inputElement = (

          <Form.Control

            type="text"

            value={value}

            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}

            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}

            isInvalid={hasError}

            required={validationOptions?.isRequired}

            placeholder={`Enter ${displayName.toLowerCase()}`}

            maxLength={validationOptions?.maxLength || undefined}

          />

        );

    }



    return (

      <Row key={fieldName}>

        <Col lg="4" md="4">

          <Form.Label>

            {displayName}

            {validationOptions?.isRequired && <span className="text-danger">*</span>}

          </Form.Label>

        </Col>

        <Col lg="8" md="8">

          {inputElement}

          {this.renderFieldError(fieldName)}

        </Col>

      </Row>

    );

  };



  render() {

    const { errors, touched } = this.state;



    const paginatedData = this.state.filteredData

      ? this.state.filteredData.slice(

        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage

      )

      : this.state.data.slice(

        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage

      );



    return (

      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />

        <div className="row">

          <div className="col-md-12 col-sm-12 col-xs-12">

            <div className="x_panel">

              <div className="x_content">

                <div

                  id="datatable_wrapper"

                  className="dataTables_wrapper form-inline

                dt-bootstrap no-footer"

                >

                  <Row className="row">

                    <div>

                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Motor Addons- Table</h3>

                    </div>

                    <Col

                      className="d-flex justify-content-end"

                      style={{ marginRight: "5px", marginTop: "20px" }}

                    >

                      <Button

                        variant="primary" style={{ float: "right", marginBottom: "10px" }}

                        className="bi bi-plus "

                        onClick={this.handleOffcanvasShow}

                      >

                        New

                      </Button>



                      {/* Enhanced Add Offcanvas */}

                      <Offcanvas

                        show={this.state.show && !this.state.isEditing}

                        onHide={this.handleOffcanvasClose}

                        {...this.props}

                        style={{ width: "500px" }}

                        placement="end"

                        backdrop="true"

                      >

                        <Offcanvas.Header closeButton>

                          <Offcanvas.Title>Add Motoraddonstable</Offcanvas.Title>

                        </Offcanvas.Header>

                        <Offcanvas.Body>

                          <Container style={{ "overflowY": "auto", height: "auto" }}>



                            {/* Error Summary */}

                            {Object.keys(errors).length > 0 && (

                              <div className="alert alert-danger mb-3">

                                <strong>Please fix the following errors:</strong>

                                <ul className="mb-0 mt-2">

                                  {Object.entries(errors).map(([field, error]) => (

                                    <li key={field}>{error}</li>

                                  ))}

                                </ul>

                              </div>

                            )}



                            <Row className="divstyle">

                              <Row>

                                <Form>

                                  <Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>Base Product Id</Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control type="text" onChange={this.handlebaseProductIdChange} className="form-control" name="baseProductId" value={this.state.baseProductId} required="required" placeholder="Enter Base Product Id" />

                                    </Col>

                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.baseProductId} </div>

                                  </Row><br /><Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>Product Name</Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control type="text" onChange={this.handleproductNameChange} className="form-control" name="productName" value={this.state.productName} required="required" placeholder="Enter Product Name" />

                                    </Col>

                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productName} </div>

                                  </Row><br /><Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>Addons</Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control type="text" onChange={this.handleaddonsChange} className="form-control" name="addons" value={this.state.addons} required="required" placeholder="Enter Addons" />

                                    </Col>

                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.addons} </div>

                                  </Row><br /><Row>

                                    <Col lg="4" md="4">

                                      <Form.Label style={{ paddingTop: "8px" }}>Default Value</Form.Label>

                                    </Col>

                                    <Col lg="8" md="8">

                                      <Form.Control type="text" onChange={this.handledefaultValueChange} className="form-control" name="defaultValue" value={this.state.defaultValue} required="required" placeholder="Enter Default Value" />

                                    </Col>

                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.defaultValue} </div>

                                  </Row><br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Addon Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleaddons_typeChange}
                                        className="form-control" name="addons_type"
                                        value={this.state.addons_type}
                                        required="required"
                                        placeholder="Enter Addon Type" />
                                    </Col>
                                  </Row><br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Max Age</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">

                                      <Form.Control type="text"
                                        onChange={this.handlemaxAgeChange}
                                        className="form-control" name="maxAge"
                                        value={this.state.maxAge}
                                        required="required"
                                        placeholder="Enter Max Age" />
                                    </Col>
                                  </Row>
                                  <br />

                                  {/* Auto-generated form content with validation */}

                                </Form>

                              </Row>

                            </Row>

                            <Row>

                              <Col

                                className="d-flex justify-content-end"

                                style={{ marginRight: "50px" }}

                              >

                                <Button

                                  className="button"

                                  variant="success"

                                  onClick={this.MotoraddonstablesubmitHandler}

                                  disabled={!this.isFormValid()}

                                  style={{

                                    marginTop: "20px",

                                  }}

                                >

                                  Save

                                </Button>

                              </Col>

                            </Row>

                          </Container>

                        </Offcanvas.Body>

                      </Offcanvas>



                      {/* Enhanced Edit Offcanvas */}

                      {this.state.isEditing && (

                        <Offcanvas

                          show={this.state.isEditing}

                          onHide={this.handleOffcanvasClose}

                          {...this.props}

                          style={{ width: "500px" }}

                          placement="end"

                          backdrop="true"

                        >

                          <Offcanvas.Header closeButton>

                            <Offcanvas.Title>Edit Motoraddonstable</Offcanvas.Title>

                          </Offcanvas.Header>

                          <Offcanvas.Body>

                            <Container style={{ "overflowY": "auto", height: "auto" }}>



                              {/* Error Summary */}

                              {Object.keys(errors).length > 0 && (

                                <div className="alert alert-danger mb-3">

                                  <strong>Please fix the following errors:</strong>

                                  <ul className="mb-0 mt-2">

                                    {Object.entries(errors).map(([field, error]) => (

                                      <li key={field}>{error}</li>

                                    ))}

                                  </ul>

                                </div>

                              )}



                              <Row className="divstyle">

                                <Row>

                                  <Form>

                                    <Row>

                                      <Col lg="4" md="4">

                                        <Form.Label style={{ paddingTop: "8px" }}>Base Product Id</Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control type="text" onChange={this.handlebaseProductIdChange} className="form-control" name="baseProductId" value={this.state.baseProductId} required="required" placeholder="Enter Base Product Id" />

                                      </Col>

                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.baseProductId} </div>

                                    </Row><br /><Row>

                                      <Col lg="4" md="4">

                                        <Form.Label style={{ paddingTop: "8px" }}>Product Name</Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control type="text" onChange={this.handleproductNameChange} className="form-control" name="productName" value={this.state.productName} required="required" placeholder="Enter Product Name" />

                                      </Col>

                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productName} </div>

                                    </Row><br /><Row>

                                      <Col lg="4" md="4">

                                        <Form.Label style={{ paddingTop: "8px" }}>Addons</Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control type="text" onChange={this.handleaddonsChange} className="form-control" name="addons" value={this.state.addons} required="required" placeholder="Enter Addons" />

                                      </Col>

                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.addons} </div>

                                    </Row><br /><Row>

                                      <Col lg="4" md="4">

                                        <Form.Label style={{ paddingTop: "8px" }}>Default Value</Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control type="text" onChange={this.handledefaultValueChange} className="form-control" name="defaultValue" value={this.state.defaultValue} required="required" placeholder="Enter Default Value" />

                                      </Col>

                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.defaultValue} </div>

                                    </Row><br /><Row>

                                      <Col lg="4" md="4">

                                        <Form.Label style={{ paddingTop: "8px" }}>Addon Type</Form.Label>

                                      </Col>

                                      <Col lg="8" md="8">

                                        <Form.Control type="text" onChange={this.handleaddons_typeChange}
                                          className="form-control" name="addons_type" value={this.state.addons_type} required="required" placeholder="Enter Addon Type" />

                                      </Col>

                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.addons_type} </div>

                                    </Row><br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Max Age</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">

                                        <Form.Control type="text"
                                          onChange={this.handlemaxAgeChange}
                                          className="form-control" name="maxAge"
                                          value={this.state.maxAge}
                                          required="required"
                                          placeholder="Enter Max Age" />
                                      </Col>
                                    </Row>

                                    {/* Auto-generated form content with validation */}

                                  </Form>

                                </Row>

                              </Row>

                              <Row>

                                <Col

                                  className="d-flex justify-content-end"

                                  style={{ marginRight: "50px" }}

                                >

                                  <Button

                                    className="button"

                                    variant="success"

                                    onClick={this.MotoraddonstableupdateHandler}

                                    disabled={!this.isFormValid()}

                                    style={{

                                      marginTop: "20px",

                                    }}

                                  >

                                    Update

                                  </Button>

                                </Col>

                              </Row>

                            </Container>

                          </Offcanvas.Body>

                        </Offcanvas>

                      )}

                      {/*offcanvas is over */}

                    </Col>

                  </Row>

                  <br />

                  <Row>

                    <div style={{ "marginRight": "5px" }}>

                      {/* searchbar,pagination,filter */}

                      <input

                        type="text"

                        style={{ float: "left", marginBottom: "10px" }}

                        onChange={this.handleFilter}

                        placeholder="Search..."

                      />

                      <DataTable

                        data={paginatedData}

                        columns={this.state.tableClms}

                        pagination

                        paginationServer

                        paginationTotalRows={

                          this.state.filteredData

                            ? this.state.filteredData.length

                            : this.state.data.length

                        }

                        onChangeRowsPerPage={this.handlePerRowsChange}

                        onChangePage={this.handlePageChange}

                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}

                        keyField="id"

                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"

                      />

                    </div>

                  </Row>



                </div>

              </div>

            </div>

          </div>

        </div>

      </div>



    );

  }

}